import AppCard from "@lib/components/AppComponents/AppCard";
import styled from "styled-components";
import { List } from "antd";

export const StyledMiniListCard = styled(AppCard)<{ useFooter: boolean }>`
  & .ant-card-head {
    border-bottom: 1px dashed ${({ theme }) => theme.palette.borderColor};
  }

  & .ant-card-body {
    // margin-left: -8px;
    // margin-right: -8px;
    display: flex;
    flex-direction: column;
    height: ${({ heightFull, useFooter, height }) =>
      height
        ? height
        : heightFull
          ? "100%"
          : `calc(265px - ${useFooter ? "40px" : "0px"})`};
    max-height: 50vh;
    overflow: auto;
  }

  & .ant-card-actions {
    padding: 0 !important;
    margin: 0 !important;

    li {
      margin: 0 !important;
      cursor: unset;
      span {
        cursor: unset;
      }
    }
  }
`;

export const StyledMiniListList = styled(List)`
  &.ant-list {
    height: 100%;
    overflow: auto;

    .ant-list-items {
      .ant-list-item {
        padding: 2px 16px;
        cursor: pointer;

        .ant-list-item-meta {
          background-color: ${({ theme }) =>
            theme.palette.background.secondary};
          border-radius: 8px;
          align-items: center;
          padding: 4px 8px;

          .ant-list-item-meta-avatar {
            padding: 0;
            margin-bottom: 0;
            line-height: 1;
          }

          .ant-list-item-meta-content {
            .ant-list-item-meta-title {
              padding: 0;
              margin: 0;
            }
            .ant-list-item-meta-description {
              background-color: transparent !important;
            }
          }
        }

        &:nth-child(even) {
          .ant-list-item-meta {
            background-color: ${({ theme }) =>
              theme.palette.background.default};
          }
        }
      }
    }
  }
`;

export const StyledMiniListFooter = styled.div`
  padding: 5px 20px !important;
  margin: 0 !important;
  color: ${({ theme }) => theme.palette.text.secondary};
  background-color: ${({ theme }) => theme.palette.background.secondary};
  display: flex;
  align-items: center;
  cursor: unset;
`;
